module.exports = __webpack_public_path__ + "img/scan.f9163c09.svg";